import axios from "axios";

export default axios.create({
    baseURL: 'https://guarded-hollows-71458.herokuapp.com',
})